'use client'
import { default as Paragraph } from '@mui/material/Typography'
// import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import CharacterCount from '@tiptap/extension-character-count'
import Document from '@tiptap/extension-document'
import Placeholder from '@tiptap/extension-placeholder'
// import Mention from '@tiptap/extension-mention'
// import Paragraph from '@tiptap/extension-paragraph'
// import Text from '@tiptap/extension-text'
import Link from '@tiptap/extension-link'
import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Typography from '@tiptap/extension-typography'
import BulletList from '@tiptap/extension-bullet-list'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import {
  EditorContent, useEditor,
  // BubbleMenu
} from '@tiptap/react'
import { Box, Divider } from '@mui/material'
import { useCallback } from 'react'
import debounce from 'lodash.debounce'

// const CustomDocument = Document.extend({
//   content: 'heading block*',
// })

const MenuBar = ({ editor }) => {
  const setLink = useCallback(() => {
    const previousUrl = editor.getAttributes('link').href
    const url = window.prompt('URL', previousUrl)

    // cancelled
    if (url === null) {
      return
    }

    // empty
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink()
        .run()

      return
    }

    // update link
    editor.chain().focus().extendMarkRange('link').setLink({ href: url })
      .run()
  }, [editor])

  if (!editor) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: 'fit-content',
        '& hr': {
          mx: 0.4,
          borderColor: '#ced4da'
        },
      }}>
      <button onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()} className={editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}>
        h1
      </button>
      <button onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} className={editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}>
        h2
      </button>
      <button onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()} className={editor.isActive('heading', { level: 3 }) ? 'is-active' : ''}>
        h3
      </button>
      <button onClick={() => editor.chain().focus().setParagraph().run()} className={editor.isActive('paragraph') ? 'is-active' : ''}>
        paragraph
      </button>
      <button onClick={() => editor.chain().focus().toggleBold().run()} className={editor.isActive('bold') ? 'is-active' : ''}>
        bold
      </button>
      <button onClick={() => editor.chain().focus().toggleItalic().run()} className={editor.isActive('italic') ? 'is-active' : ''}>
        italic
      </button>
      <button onClick={() => editor.chain().focus().toggleStrike().run()} className={editor.isActive('strike') ? 'is-active' : ''}>
        strike
      </button>
      <button onClick={() => editor.chain().focus().toggleHighlight().run()} className={editor.isActive('highlight') ? 'is-active' : ''}>
        highlight
      </button>
      <Divider orientation="vertical" variant="middle" flexItem />
      <button onClick={() => editor.chain().focus().toggleBulletList().run()} className={editor.isActive('bulletList') ? 'is-active' : ''}>
        bullet list
      </button>
      <button onClick={() => editor.chain().focus().toggleOrderedList().run()} className={editor.isActive('orderedList') ? 'is-active' : ''}>
        ordered list
      </button>
      <button onClick={() => editor.chain().focus().sinkListItem('listItem').run()} disabled={!editor.can().sinkListItem('listItem')}>
        sink list item
      </button>
      <button onClick={() => editor.chain().focus().liftListItem('listItem').run()} disabled={!editor.can().liftListItem('listItem')}>
        lift list item
      </button>
      <Divider orientation="vertical" variant="middle" flexItem />
      <button onClick={() => editor.chain().focus().toggleBlockquote().run()} className={editor.isActive('blockquote') ? 'is-active' : ''}>
        blockquote
      </button>
      <button onClick={() => editor.chain().focus().setHorizontalRule().run()}>
        horizontal rule
      </button>
      <button onClick={() => editor.chain().focus().setHardBreak().run()}>
        hard break
      </button>
      <Divider orientation="vertical" variant="middle" flexItem />
      <button onClick={() => editor.chain().focus().unsetAllMarks().run()}>
        clear marks
      </button>
      <button onClick={() => editor.chain().focus().clearNodes().run()}>
        clear nodes
      </button>
      <Divider orientation="vertical" variant="middle" flexItem />
      <button onClick={() => editor.chain().focus().setTextAlign('left').run()} className={editor.isActive({ textAlign: 'left' }) ? 'is-active' : ''}>
        left
      </button>
      <button onClick={() => editor.chain().focus().setTextAlign('center').run()} className={editor.isActive({ textAlign: 'center' }) ? 'is-active' : ''}>
        center
      </button>
      <button onClick={() => editor.chain().focus().setTextAlign('right').run()} className={editor.isActive({ textAlign: 'right' }) ? 'is-active' : ''}>
        right
      </button>
      <button onClick={() => editor.chain().focus().setTextAlign('justify').run()} className={editor.isActive({ textAlign: 'justify' }) ? 'is-active' : ''}>
        justify
      </button>
      <Divider orientation="vertical" variant="middle" flexItem />
      <input
        type="color" className="color-btn"
        onInput={event => editor.chain().focus().setColor(event.target.value).run()}
        value={editor.getAttributes('textStyle').color}
        data-testid="setColor"
      />
      <button onClick={() => editor.chain().focus().unsetColor().run()} data-testid="unsetColor"  >
        unset color
      </button>
      <Divider orientation="vertical" variant="middle" flexItem />
      <button onClick={setLink} className={editor.isActive('link') ? 'is-active' : ''}>
        set link
      </button>
      <button onClick={() => editor.chain().focus().unsetLink().run()} disabled={!editor.isActive('link')}>
        unset link
      </button>
      <Divider orientation="vertical" variant="middle" flexItem />
      <button
        onClick={() => editor.chain().focus().undo().run()}
        disabled={
          !editor.can()
            .chain()
            .focus()
            .undo()
            .run()
        }
      >
        undo
      </button>
      <button
        onClick={() => editor.chain().focus().redo().run()}
        disabled={
          !editor.can()
            .chain()
            .focus()
            .redo()
            .run()
        }
      >
        redo
      </button>
    </Box>
  )
}

const Note = ({ data, setFocus, onDataChange, handleAutoSave, checked, isSystemDefault, selectedWatchlistNotes, editorhead }) => {

  // if (isSystemDefault && (data === "" || !data)) {
  //   return null;
  // }

  // if (data === "" || !data) {
  //   return null;
  // }

  const debouncedOnChange = debounce(onDataChange, 777);

  const debouncedAutoSave = debounce(handleAutoSave, 777);

  const limit = 1000

  const editor = data ?
    useEditor({
      extensions: [
        // CustomDocument,
        StarterKit.configure({ document: false, }),
        TextAlign.configure({ types: ['heading', 'paragraph'], }),
        Highlight, TextStyle, Color, Link, Typography, BulletList, OrderedList, ListItem,
        Placeholder.configure({ placeholder: 'Start adding your ideas...' }),
        // placeholder: ({ node }) => {
        //   if (node.type.name === 'heading') {
        //     return 'Add your notes here...'
        //   }

        //   return 'Start adding your ideas...'
        // },
        // }),
        Document,  // Paragraph,  // Text,
        CharacterCount.configure({ limit, }),
      ],
      content: data ?? selectedWatchlistNotes,
      editable: !isSystemDefault,
      onFocus: (event) => { setFocus(true) },
      onBlur: (event) => { setFocus(false) },
      onUpdate({ editor }) { checked ? debouncedAutoSave(editor.getHTML()) : debouncedOnChange(editor.getHTML()) },
    }) : useEditor({
      extensions: [
        StarterKit.configure({ document: false, }),
        TextAlign.configure({ types: ['heading', 'paragraph'], }),
        Placeholder.configure({ placeholder: 'Start adding your ideas...' }),
        CharacterCount.configure({ limit, }),
        Highlight, TextStyle, Color, Link, Typography, BulletList, OrderedList, ListItem, Document,
      ],
      content: selectedWatchlistNotes,
      editable: !isSystemDefault,
      onFocus: (event) => { setFocus(true) },
      onBlur: (event) => { setFocus(false) },
      onUpdate({ editor }) { checked ? debouncedAutoSave(editor.getHTML()) : debouncedOnChange(editor.getHTML()) },
    }, [selectedWatchlistNotes])

  if (!editor) {
    return null
  }

  const percentage = editor
    ? Math.round((100 / limit) * editor?.storage?.characterCount?.characters())
    : 0

  return (
    <>
      <Box component="div" sx={{ position: 'relative' }}>
        {editorhead}
        <Box component="div" className="note-section-menu">
          <MenuBar editor={editor} />
        </Box>
      </Box>
      <Box component="div" sx={{ position: 'relative' }}>
        <EditorContent editor={editor} />
        {editor &&
          <Box component="div" sx={{ display: 'flex', '& .character-count__text': { ml: 1 }, alignItems: 'center' }} className={`character-count ${editor?.storage?.characterCount?.characters() === limit ? 'character-count--warning' : ''}`}>
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              className="character-count__graph"
            >
              <circle
                r="10"
                cx="10"
                cy="10"
                fill="#ced4da"
              />
              <circle
                r="5"
                cx="10"
                cy="10"
                fill="transparent"
                stroke="rgb(67, 65, 102)"
                strokeWidth="10"
                strokeDasharray={`calc(${percentage} * 31.4 / 100) 31.4`}
                transform="rotate(-90) translate(-20)"
              />
              <circle
                r="6"
                cx="10"
                cy="10"
                fill="white"
              />
            </svg>

            <div className="character-count__text" style={{ color: '#a2a0a0' }}>
              {editor?.storage?.characterCount?.characters()}/{limit} characters
            </div>
          </Box>}
      </Box>
    </>
  )
}

export default Note

// import { Box } from '@mui/material';
// import dynamic from 'next/dynamic'
// import { useState } from 'react';

// const QuillNoSSRWrapper = dynamic(import('react-quill'), {
//   ssr: false,
//   loading: () => <p>Loading ...</p>,
// })

// const modules = {
//   toolbar: [
//     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
//     // [{ header: '1' }, { header: '2' }, { font: [] }],
//     // [{ size: [] }],
//     ['bold', 'italic', 'underline', 'strike', 'blockquote'],
//     [
//       { list: 'ordered' },
//       { list: 'bullet' },
//       { indent: '-1' },
//       { indent: '+1' },
//     ],
//     // ['link', 'image', 'video'],
//     ['link'],
//     // ['clean'],
//     [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
//     [{ 'font': [] }],
//     [{ 'align': [] }],
//   ],
//   clipboard: {
//     // toggle to add extra line breaks when pasting HTML:
//     matchVisual: false,
//   },
// }
// /*
//  * Quill editor formats
//  * See https://quilljs.com/docs/formats/
//  */
// const formats = [
//   'header',
//   'font',
//   'size',
//   'bold',
//   'italic',
//   'underline',
//   'strike',
//   'blockquote',
//   'list',
//   'bullet',
//   'indent',
//   'link',
//   'image',
//   'video',
// ]

// export default function Note() {
//   const [value, setValue] = useState('');
//   const [hidetool, setHidetool] = useState(false);
//   const onblur = () => { setHidetool(true) }
//   const onfocus = () => { setHidetool(false) }
//   return (
//     <Box sx={{ '& .ql-toolbar': { display: hidetool ? 'none' : 'block' } }}>
//       <QuillNoSSRWrapper
//         theme="snow"
//         placeholder='compose here'
//         value={value}
//         onChange={setValue}
//         hasFocus={onblur}
//         onFocus={onfocus}
//         modules={modules}
//         formats={formats}
//       />
//     </Box>)
// }
